import { MmBAppConstants } from '@src/ib-MmB-constants';
import angular from 'angular';

@Config('ib-MmB-routing-module')
class ibRouterConfig {

    constructor (
        private $routeProvider,
        private MmBRouterConstants
    ) {}

    active = (): void => {
        this.$routeProvider.
            when(this.MmBRouterConstants.PAGES_URL.SEARCH, {
                template: '<ib-mmb-search-component></ib-mmb-search-component>',
                reloadOnSearch: false
            }).when(this.MmBRouterConstants.PAGES_URL.BOOKING_MANAGE, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.managementViewRoute,
                controller: 'BookingManagementController',
                controllerAs: 'manageCtrl',
                reloadOnSearch: false
            }).when(this.MmBRouterConstants.PAGES_URL.CHANGE_FLIGHT, {
                template: '<ib-change-flight-component></ib-change-flight-component>',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-change-flight').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-change-flight-templates'));
                            $ocLazyLoad.load(angular.module('ib-Mmb-change-flight-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.FLIGHT_CONFIRMATION, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.flightConfirmationViewRoute,
                controller: 'FlightConfirmationController',
                controllerAs: 'confirmCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-flight-confirmation').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-flight-confirmation-templates'));
                            $ocLazyLoad.load(angular.module('ib-MmB-flight-confirmation-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.BOOKINGS_LIST, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.bookingsListViewRoute,
                controller: 'BookingsListController',
                controllerAs: 'bookingsCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-bookings-list').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-bookings-list-templates'));
                            $ocLazyLoad.load(angular.module('ib-MmB-bookings-list-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.PASSENGERS_INFO, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.passengersInfoView,
                controller: 'PassengersInfoController',
                controllerAs: 'passInfoCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-passengers-info').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-passengers-info-templates'));
                            $ocLazyLoad.load(angular.module('ib-MmB-passengers-info-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.ON_HOLD_CONFIRMATION, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.onHoldConfirmationViewRoute,
                controller: 'OnHoldConfirmationController',
                controllerAs: 'onHoldConfCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-on-hold-confirmation').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-on-hold-confirmation-templates'));
                            $ocLazyLoad.load(angular.module('ib-MmB-on-hold-confirmation-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.PAYMENTS, {
                template: this.MmBRouterConstants.mmbPaymentTemplate,
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-payments').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                            $ocLazyLoad.load(angular.module('ib-pmt-app'));
                            $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-communication-lost-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-mmb-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-injectable-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.MMB_PAYMENTS_CONFIRM, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.paymentsConfirmMmbRoute,
                controller: 'ConfirmationMMbController',
                controllerAs: 'paymentConfirmationCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-payments').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                            $ocLazyLoad.load(angular.module('ib-pmt-app'));
                            $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-communication-lost-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-mmb-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-injectable-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.NEW_MMB_PAYMENTS_CONFIRM, {
                template: this.MmBRouterConstants.mmbConfirmationTemplate,
                reloadOnSearch: false,
            }).when(this.MmBRouterConstants.PAGES_URL.ON_HOLD_ANULATION, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.onHoldAnulationViewRoute,
                controller: 'OnHoldAnulationController',
                controllerAs: 'onHoldAnulCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-on-hold-anulation').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-on-hold-anulation-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.MMB_CONFIRMATION_ORDER, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.confirmationMmbOrderViewRoute,
                controller: 'PmtConfirmationController',
                controllerAs: 'pmtConfOrderCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-payments').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                            $ocLazyLoad.load(angular.module('ib-pmt-app'));
                            $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-communication-lost-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-mmb-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-injectable-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.MMB_COMMUNICATION_LOST, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.mmbCommunicationLostViewRoute,
                controller: 'PmtCommunicationLostController',
                controllerAs: 'pmtComLostCtr',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-web-payments').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-payments-templates'));
                            $ocLazyLoad.load(angular.module('ib-pmt-app'));
                            $ocLazyLoad.load(angular.module('ib-pmt-order-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-communication-lost-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-mmb-confirmation-module'));
                            $ocLazyLoad.load(angular.module('ib-pmt-injectable-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.MMB_DASHBOARD, {
                template: '<ib-Mmb-booking-dashboard-component></ib-Mmb-booking-dashboard-component>',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-dashboard').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-dashboard-templates'));
                            $ocLazyLoad.load(angular.module('ib-health-form-module'));
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                            $ocLazyLoad.load(angular.module('ib-MmB-booking-dashboard-module'));
                            $ocLazyLoad.load(angular.module('ib-MmB-gastronomic-proposal-module'));
                            $ocLazyLoad.load(angular.module('ib-disruption-main-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.MMB_INVOLUNTARY_CHANGE, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.mmbInvoluntaryChangeViewRoute,
                controller: 'MmBInvoluntaryChangeController',
                controllerAs: 'mmBInvoluntaryChangeCtrl',
                reloadOnSearch: false
            }).when(this.MmBRouterConstants.PAGES_URL.DISRUPTION_DASHBOARD, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.disruptionDashboardRoute,
                controller: 'DisruptionDashboardController',
                controllerAs: 'disruptionCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-dashboard').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-dashboard-templates'));
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                            $ocLazyLoad.load(angular.module('ib-MmB-booking-dashboard-module'));
                            $ocLazyLoad.load(angular.module('ib-disruption-main-module'));
                            $ocLazyLoad.load(angular.module('ib-disruption-refund-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.DISRUPTION_REFUND, {
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.disruptionRefundRoute,
                controller: 'DisruptionRefundController',
                controllerAs: 'disrefundCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-dashboard').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-dashboard-templates'));
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                            $ocLazyLoad.load(angular.module('ib-MmB-booking-dashboard-module'));
                            $ocLazyLoad.load(angular.module('ib-disruption-main-module'));
                            $ocLazyLoad.load(angular.module('ib-disruption-refund-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.REBOOK_ERROR,{
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.rebookErrorViewRoute,
                controller: 'MmbRebookErrorController',
                controllerAs: 'mmbRebookErroryCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-rebook-error').then(() => {
                            $ocLazyLoad.load(angular.module('ib-MmB-rebook-error-module'));
                        });
                    }]
                }
            }).when(this.MmBRouterConstants.PAGES_URL.ANCILLARIES,{
                templateUrl: this.MmBRouterConstants.templatesRoute + this.MmBRouterConstants.ancillariesRoute,
                controller: 'AncillariesController',
                controllerAs: 'ancillariesCtrl',
                reloadOnSearch: false,
                resolve: {
                    load: ['$ocLazyLoad', ($ocLazyLoad) => {
                        return import('@src/lazy-loading/ib-MmB-ancillaries-page').then(() => {
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-page-templates'));
                            $ocLazyLoad.load(angular.module('ib-web-ancillaries-module'));
                            $ocLazyLoad.load(angular.module('ib-MmB-ancillaries-page-module'));
                        });
                    }]
                }
            }).when('/loading', {
                template: '<ib-loading-redirection></ib-loading-redirection>',
                reloadOnSearch: false,
            })
            .otherwise({ redirectTo: this.MmBRouterConstants.PAGES_URL.SEARCH });
    }

    $onInit = this.active();
}
ibRouterConfig.$inject = ['$routeProvider', 'MmBRouterConstants'];
